import { Socket } from "socket.io-client";

import { DashboardExportUpdate } from "@ark/shared";

import { createNamespaceSocket } from "./websocket-connection";

export type ExportCompletedPayload = Extract<DashboardExportUpdate, { type: "completed" }>;

export type ExportFailedPayload = Extract<DashboardExportUpdate, { type: "failed" }>;

export interface DashboardExportSocketHandlers {
  onCompleted: (payload: ExportCompletedPayload) => void;
  onFailed: (payload: ExportFailedPayload) => void;
}

export class DashboardExportWebSocketService {
  private socket: Socket | null = null;

  connect(handlers: DashboardExportSocketHandlers): void {
    if (this.socket) {
      return;
    }

    const socket = createNamespaceSocket("dashboard-export");
    if (!socket) {
      return;
    }

    this.socket = socket;
    this.socket.on("export-completed", handlers.onCompleted);
    this.socket.on("export-failed", handlers.onFailed);
  }

  disconnect(): void {
    if (!this.socket) {
      return;
    }
    this.socket.removeAllListeners();
    this.socket.disconnect();
    this.socket = null;
  }
}

export const dashboardExportWebSocket = new DashboardExportWebSocketService();
